// AWS Amplify configuration for Proofivy contact form
// Replace these values with your actual AWS Amplify endpoint after deployment

export const amplifyConfig = {
  // This is the AWS region where your Amplify resources are deployed
  region: 'eu-west-2', // Updated with correct region

  // API Gateway endpoints configuration
  API: {
    endpoints: [
      {
        name: 'contactAPI',
        // Replace this with your actual API Gateway endpoint after deployment
        endpoint: 'https://cxkkpifjlg.execute-api.eu-west-2.amazonaws.com/dev',
        region: 'eu-west-2',
      },
    ],
  },
};
